import React from 'react';
import ModalLoadingOverlay from '../ModalLoadingOverlay';
import StyledModal from './styled';

/**
 * This component can be used to let the case manager know something is actively being processed.
 */

const LoadingModal = ({ title, visible, subtitle }) => (
  <StyledModal footer={[]} closeIcon={null} visible={visible} zIndex={999999}>
    <ModalLoadingOverlay title={title} subtitle={subtitle} />
  </StyledModal>
);

export default LoadingModal;
